import { createSlice } from '@reduxjs/toolkit';

export const drawersSlice = createSlice({
    name: 'drawers',
    initialState: {
        isContactUsDrawerOpen: false,
        isBigBookingWidgetDrawerOpen: false,
        isMultipropertyDrawerOpen: false,
        isMobileMultipropertyDrawerOpen: false,
        isMapDrawerOpen: false,
        isPropertySidebarDrawerOpen: false,
    },
    reducers: {
        openDrawer: (state, action) => {
            state[`is${action.payload.drawerId}Open`] = true;
        },
        closeDrawer: (state, action) => {
            state[`is${action.payload.drawerId}Open`] = false;
        },
    },
});

export const { openDrawer, closeDrawer } = drawersSlice.actions;
